function openOnglet(ongletActive, section, index) {
  var sectionElement = document.querySelector(section);

  var ongletAll = sectionElement.querySelectorAll(".mm-oi-onglet-title");
  ongletAll.forEach(function (onglet) {
		if (onglet === ongletActive) {
			onglet.classList.add("mm-active");
		} else {
			onglet.classList.remove("mm-active");
		}
  });

  var contentAll = sectionElement.querySelectorAll(".mm-oi-content");
  var contentActive = `mm-oi-content-${index}`;

  contentAll.forEach(function (content) {
		if (content.classList.contains(contentActive)) {
			content.classList.remove('mm-none');
		} else {
			content.classList.add('mm-none');
		}
  });
}
